import { createEndpoint } from "config/apiEndpoints";
import { PostData } from "hooks/api/useApiService";
import React, { useState } from "react";
import useToasterStore from "store/SnackBar/useToasterStore";
import { useFormik } from "formik";
import * as Yup from "yup";
import { getUserType } from "store/userType";
import { deleteFromStorage, getFromStorage } from "utils/storage";
import { useHistory } from "react-router-dom";
import { generalStore } from "store/generalStore";
import useProfileApi from "../Profile/useProfileApi";

const useChangePasswordController = (handleModalClose) => {
  const [showPassword, setShowPassword] = useState(false);
  const [showPassword1, setShowPassword1] = useState(false);
  const [showPassword2, setShowPassword2] = useState(false);

  const openToaster = useToasterStore((state) => state.openToaster);
  const userData =
    getUserType((state) => state.userData) || getFromStorage("user_data");
  const isUserType = getUserType((state) => state.isUserType);
  const setSelectedProject = generalStore((state) => state.setSelectedProject);
  const setUserType = getUserType((state) => state.setUserType);
  const setChangePasswordModal = generalStore(
    (state) => state.setChangePasswordModal
  );
  const { mutateLogOut } = useProfileApi();

  const passwordRegex =
    /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]{8,}$/;
  const handleClickShowPassword = () => setShowPassword((show) => !show);
  const handleClickShowPassword1 = () => setShowPassword1((show) => !show);
  const handleClickShowPassword2 = () => setShowPassword2((show) => !show);


  const history = useHistory();
  const goToOtherPage = (route) => {
    history.push(route);
  };

  const handleMouseDownPassword = (event) => {
    event.preventDefault();
  };

  // const handleLogout = () => {
  //   setSelectedProject(null);
  //   goToOtherPage("/login");
  //   deleteFromStorage("user_data");
  //   localStorage.clear();
  //   // deleteFromStorage("generalStore")
  //   setUserType(null);
  //   // deleteFromStorage("expire")
  // };

  const changePasswordAction = {
    onSuccess: (data) => {
      if (data.data.statusCode == 200) {
        openToaster("success", "You have changed your password");
        formik.resetForm();
        // handleModalClose();
        setChangePasswordModal(false);
        mutateLogOut();
      }
    },
    onError: (error) => {
      const errorMessage = error?.response?.data?.data?.GeneralError[0];
      openToaster(
        "error",
        errorMessage || "something went wrong, Try again later!!!"
      );
    },
  };

  const { mutate: mutateChangePass, isLoading: isChangePassLoading } = PostData(
    createEndpoint("changePassword"),
    "put",
    changePasswordAction
  );
  const validationSchema = (values) => {
    return Yup.object().shape({
      oldPassword: Yup.string().required("Please Enter Your Password"),
      newPassword: Yup.string()
        .matches(
          passwordRegex,
          "Password entered must have a \n - Min 8 character\n - Min 1 number\n - Min 1 alphabet\n - one uppercase letter, one lowercase letter, one number, one special character"
        )
        .required("Please Enter Your New Password"),
      confirmNewPassword: Yup.string()
        .oneOf([Yup.ref("newPassword"), null], "Password must match")
        .required("Please Confirm Your New Password"),
    });
  };


  const formik = useFormik({
    initialValues: {
      emailAddress: userData?.email_address,
      oldPassword: "",
      newPassword: "",
      confirmNewPassword: "",

      // date: "",
    },
    validationSchema: () => validationSchema(formik.values),
    onSubmit: (values) => {
      const payload = {
        emailAddress: values?.emailAddress,
        oldPassword: values?.oldPassword,
        newPassword: values?.newPassword,
      };

      mutateChangePass(payload);
    },
  });
  return {
    formik,
    showPassword,
    handleMouseDownPassword,
    handleClickShowPassword,
    isChangePassLoading,
    handleClickShowPassword1,
    handleClickShowPassword2,
    showPassword1,
    showPassword2
  };
};

export default useChangePasswordController;
